export default {
  CardsData: {
    children: [
      {
        Key: 1,
        heading: 'Personal Info',
        subHeading:
          'Name should be displayed exactly as you do on your cover letter Email address should be active and professional. Only include relevant online profile links in your resume.',
      },
      {
        Key: 2,
        heading: 'Education',
        subHeading:
          'Present your education history in reverse chronological order. Try to minimize your levels of degrees to two in your resume as they are most important ones.',
      },
      {
        Key: 3,
        heading: 'Work Experience/Projects',
        subHeading:
          'Only list the experience that is relevant to the position you are applying for. Choose compelling action verbs to show off your achievements.',
      },
      {
        Key: 4,
        heading: 'Skills',
        subHeading:
          'Divide your skills into respective sub-sections. Try to include both full name and abbreviations (if applicable) for passing applicant tracking system (ATS).',
      },
    ],
    data: [
      {
        Key: 1,
        heading: 'Additional Customizations at No Cost',
        subHeading: `We understand that you prefer students from your organization to adhere to certain standards when creating a resume or cover letter. Wisedoc's team will customize the tool according to your standards at no cost, ensuring that the software recommendations align with advisor guidelines.`,
      },
      {
        Key: 2,
        heading: 'Campaigning Support for User Acquisition',
        subHeading:
          'Advisors exert a significant effort to share the tools with students and help them use them. Wisedoc provides workshops for both students and the advisor team, aiming to acquire users and alleviate the advisor burden.',
      },
      {
        Key: 3,
        heading: 'Tutorials for Reducing Learning Curve',
        subHeading:
          'We provide video tutorials for the latest versions of the software, directly accessible from the platform. These short tutorials clear the learning curve for using the software and enable students to focus on the content.',
      },
    ],
  },
  HeadingData: {
    children: [
      {
        heading1: 'How to Write a Resume?',
        subHeading1:
          'Get simple and effective tips to guide you in writing an impressive resume.',
      },
    ],
  },
  resumeTemplateData: {
    children: [
      {
        imgSrc: 'https://gatsby.wisedoc.net/resumeImage-WAR-section.jpg',
        alt: 'Resume Template',
      },
    ],
  },
};
